<template>
<div id="ccDetalheTorneio">

  <!-- Modal -->
  <div class="modal fade" id="modal_jogo_resultado" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">

      <div class="modal-content">
        <div class="modal-body">
          <div class="col-md-12" style="padding: 8px; margin-bottom: 10px; border-radius: 10px;">

            <div class="row" style="margin-bottom:10px">
              <div class="col-12 text-center text_13">
                {{resultado.liga_nome}}
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-4">
                <p class="text-center">
                  <img :src='resultado.localteam_logo' class="imagem" :title='"sokkerduel"' width="30px"> <br>
                  <span style="font-size: 12px; color: #a3a3a3;"> {{resultado.localteam_nome}} </span>
                </p>
              </div>
              <div class="col-4">
                <div style="text-align:center; color:#fff; font-size:12px; font-weight:bolder;">
                  <img src='../../assets/image/ponto.gif' width="10px" v-if="resultado.status == 'LIVE'" > &nbsp; {{resultado.status}}
                </div>
                <div class="text-center">
                  <span style="font-size: 40px; font-weight: bolder; color: green;">
                    {{resultado.localteam_score}} : {{resultado.visitorteam_score}}
                  </span>
                  <br>
                  <span style="font-size: 15px; font-weight: bolder; color: red;">
                    {{resultado.minute}}'
                  </span>
                </div>
              </div>
              <div class="col-4">
                <p class="text-center">
                  <img :src='resultado.visitorteam_logo' class="imagem" :title='"sokkerduel"' width="30px"> <br>
                  <span style="font-size: 12px; color: #a3a3a3;"> {{resultado.visitorteam_nome}} </span>
                </p>
              </div>
            </div>

            <div class="row">
              <div class="col-6">
                <div class="btn_detalhes"> Detalhes </div>
              </div>
              <div class="col-6">
                <div class="btn_estatisticas"> Estatísticas </div>
              </div>
            </div>

          </div>

          <div class="col-md-12 text_12" style="padding: 20px; margin-bottom: 20px; border-radius: 10px;">
            <div v-for="resu of escanteios">
              <div class="row" v-if="resu.team_id == resultado.time1">
                <div class="col-12" v-if="resu.tipo == 'corner'">
                  <img src='../../assets/image/bandeirinha.png' width="15px"> <b> {{resu.minute}}'</b>  {{resu.comment}} <br> <br>
                </div>
                <div class="col-12" v-if="resu.tipo == 'goal'">
                  <img src='../../assets/image/bola.png' width="15px"> <b> {{resu.minute}}'</b>  {{resu.player_name}} <br> <br>
                </div>
              </div>

              <div class="row" v-if="resu.team_id == resultado.time2">
                <div class="col-12 text-end" v-if="resu.tipo == 'corner'">
                  <img src='../../assets/image/bandeirinha.png' width="15px"> <b> {{resu.minute}}'</b>  {{resu.comment}} <br> <br>
                </div>
                <div class="col-12 text-end" v-if="resu.tipo == 'goal'">
                  <img src='../../assets/image/bola.png' width="15px"> <b> {{resu.minute}}'</b>  {{resu.player_name}} <br> <br>
                </div>
              </div>
            </div>
          </div>


        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Fechar</button>
        </div>
      </div>

    </div>
  </div>

</div>
</template>

<script>

  import axios from 'axios';
  export default {

    name: 'ccDetalheTorneio',

    data(){
      return{
        //geral
        base_url_api: process.env.BASE_URL_API,
        user: {},
        loading: false,
        errors:[],

        //variaveis
        jogo: {},
        resultado: {},
        escanteios: [],
      }
    },

    methods: {

      mounted(){
        let a = JSON.parse(localStorage.getItem("user"));

        if (a == null){
          this.user = {}
        }else{
          this.user = a
        }
      },

      receber_dados(resultado, escanteios){
        this.resultado = resultado
        this.escanteios = escanteios
        var myModal = new bootstrap.Modal(document.getElementById('modal_jogo_resultado'))
        myModal.show()
      },


    },

  }

</script>


<style scoped>

    .modal-content{
      background-color: #292c38;
      color: #fff;
    }

    .texto{
      padding: 10px, 0, 10px, 0;
      font-size: 17px;
    }


    /* RSULTADOS ----------------------------- */

    .btn_detalhes{
      width: 115px;
      height: 28px;
      border-radius: 10px;
      font-size: 12px;
      background-color: rgba(153, 173, 228, 0.3);
      text-align: center;
      padding-top: 5px;
      float: right;
    }

    .btn_estatisticas{
      width: 115px;
      height: 28px;
      border-radius: 10px;
      font-size: 12px;
      background-color: transparent;
      text-align: center;
      padding-top: 5px;
      float: left;
      border: solid 1px rgba(153, 173, 228, 0.3);
    }

</style>


// WEBPACK FOOTER //
// src/components/cc_geral/cc_jogo_resultado.vue